<div class="cxone-games-connect-3-slot-container">
    <div class="slot slot-empty" *ngIf="slotType === 'empty'" [ngbPopover]="connect3popover" placement="bottom"
        container="body" triggers="mouseenter:mouseleave" popoverClass="cxone-connect-3-tooltip" triggers="manual" #tooltipConnect3="ngbPopover"
        (mouseenter)="tooltipConnect3.open()" (mouseleave)="tooltipConnect3.close()" (wheel)="tooltipConnect3.close()">
    </div>
    <div class="slot slot-selected" *ngIf="slotType === 'completed' || slotType === 'completedBlackout'"
        [ngbPopover]="connect3popover" placement="bottom" container="body" triggers="mouseenter:mouseleave"
        popoverClass="cxone-connect-3-tooltip"triggers="manual" #tooltipConnect3Completed="ngbPopover"
        (mouseenter)="tooltipConnect3Completed.open()" (mouseleave)="tooltipConnect3Completed.close()" (wheel)="tooltipConnect3Completed.close()">
        <svg class="icon-16">
            <use href="../../../App_Themes/CXone/icons/gamification/games/connect-3-check.svg#connect-3-check"></use>
        </svg>
    </div>
    <div class="slot slot-free" *ngIf="slotType === 'freeSpace' || slotType === 'freeSpaceBlackout'">
        <span>Free</span>
    </div>
</div>
<ng-template #connect3popover>
    <p class="tooltip-title-text">
        {{tooltipTitle}}</p>
    <p class="tooltip-content-text">{{tooltipTargetDirection === 0 ? '\<' : '>'}} {{tooltipTarget}}</p>
</ng-template>